import React from "react";
import { Card, CardGrid, Content, Header, Icon, Logo, ServiceCard, ServiceDescription, ServiceTitle, Status, User } from "./styles";

const Mockup = () => {
    return (
        <Card>
            <Header>
                <Logo>NanoCode</Logo>

                <User>
                    <Status />
                    Online
                </User>
            </Header>

            <Content>
                <CardGrid>
                    <ServiceCard>
                        <Icon>🌐</Icon>

                        <ServiceTitle>
                            Landing Pages
                        </ServiceTitle>

                        <ServiceDescription>
                            Convierte visitantes en clientes.
                        </ServiceDescription>
                    </ServiceCard>

                    <ServiceCard>
                        <Icon>💻</Icon>

                        <ServiceTitle>
                            Aplicaciones Web
                        </ServiceTitle>

                        <ServiceDescription>
                            Software desarrollado a medida.
                        </ServiceDescription>
                    </ServiceCard>

                    <ServiceCard>
                        <Icon>⚙️</Icon>

                        <ServiceTitle>
                            Automatización
                        </ServiceTitle>

                        <ServiceDescription>
                            Optimiza tareas y procesos.
                        </ServiceDescription>
                    </ServiceCard>

                    <ServiceCard>
                        <Icon>✨</Icon>

                        <ServiceTitle>
                            IA Generativa
                        </ServiceTitle>

                        <ServiceDescription>
                            Contenido visual impulsado por IA.
                        </ServiceDescription>
                    </ServiceCard>
                </CardGrid>
            </Content>
        </Card>
    )
};

export default Mockup;